import styled from 'styled-components';

const experimentalButtonMixin = `
   border-radius: 8px 8px 0 0;
   border: none;
   background: #e8f4ff;
   color: #39444f !important;
   text-transform: inherit;
   font-size: 14px !important;
      &:hover {
        background-color: #e8f4ff !important;
        color: rgba(57, 68, 79, 0.9) !important;
      }
    }
`;

export const ToFormButtonContainer = styled.div`
  margin-left: auto;
  position: relative;

  .inner-description-container {
    display: flex;
    flex-direction: column;    
  }
      
  .free {
    position: absolute;
    top: 6px;    
    align-self: baseline;    
    font-size: 11px;
    background: #64b82a;
    letter-spacing: -0.3px;
    color: white;
    padding: 1px 2px;
    border-radius: 2px;

    @media screen and (max-width: 320px) {    
      display: none;    
    }
  }

  @media screen and (min-width: 1024px) {
    .experimental-button {
      height: 63px !important;
      ${experimentalButtonMixin};
  }

  @media screen and (min-width: 321px) and (max-width: 1024px) {
    .experimental-button {
      height: 55px !important;
      ${experimentalButtonMixin};
    }
  }

  @media screen and (max-width: 320px) {
    margin: inherit;
    width: 100%;

    .to-form-button {
      width: 100%;

      & button {
        width: 100%;
      }
    }
  }
`;
